import apiClient from 'services/axios'
/* eslint-disable */

const handleWalletResponse = response => response.data

const handleWalletError = (err, fallback) => {
  console.error(fallback, err)
  return {
    error: true,
    message: err?.response?.data?.message || fallback,
  }
}

export async function sendWalletSignupText(payload) {
  return apiClient
    .post('/wallet/admin/signups/communicate/text', payload)
    .then(handleWalletResponse)
    .catch(err => handleWalletError(err, 'Error sending wallet signup SMS'))
}

export async function fetchFyntiqWalletStats() {
  return apiClient
    .get('/wallet/admin/stats')
    .then(handleWalletResponse)
    .catch(err => handleWalletError(err, 'Error fetching wallet stats'))
}

export async function fetchFyntiqWalletSignups({
  page = 1,
  limit = 20,
  search = '',
  platform = '',
} = {}) {
  const params = new URLSearchParams({ page, limit })
  if (search) params.set('search', search)
  if (platform) params.set('platform', platform)

  return apiClient
    .get(`/wallet/admin/signups?${params.toString()}`)
    .then(handleWalletResponse)
    .catch(err => handleWalletError(err, 'Error fetching wallet signups'))
}

export async function fetchAllFyntiqWallets({
  page = 1,
  limit = 20,
  search = '',
  status = '',
  view = '',
  restrictionTypes = '',
} = {}) {
  const params = new URLSearchParams({ page, limit })
  if (search) params.set('search', search)
  if (status) params.set('status', status)
  if (view) params.set('view', view)
  if (restrictionTypes) params.set('restrictionTypes', restrictionTypes)

  return apiClient
    .get(`/wallet/admin/all?${params.toString()}`)
    .then(handleWalletResponse)
    .catch(err => handleWalletError(err, 'Error fetching wallets'))
}

export async function exportPlaidBanks(userId) {
  const params = userId ? `?userId=${encodeURIComponent(userId)}` : ''
  return apiClient
    .get(`/wallet/admin/export/plaid-banks${params}`)
    .then(handleWalletResponse)
    .catch(err => handleWalletError(err, 'Error exporting Plaid bank data'))
}

export async function fetchAllWalletTransactionsAdmin({
  page = 1,
  limit = 20,
  search = '',
  transaction_type = '',
  method = '',
  status = '',
  startDate = '',
  endDate = '',
} = {}) {
  const params = new URLSearchParams({ page, limit })
  if (search) params.set('search', search)
  if (transaction_type) params.set('transaction_type', transaction_type)
  if (method) params.set('method', method)
  if (status) params.set('status', status)
  if (startDate) params.set('startDate', startDate)
  if (endDate) params.set('endDate', endDate)

  return apiClient
    .get(`/transaction/admin/all?${params.toString()}`)
    .then(handleWalletResponse)
    .catch(err => handleWalletError(err, 'Error fetching transactions'))
}
